import { useEffect, useRef, useState } from 'react'

const VIDEOS = [
  { id: '4S2H-tJzHbg', tagKey: 'v1_tag', titleKey: 'v1_title' },
  { id: 'bfC5O7V6mFk', tagKey: 'v2_tag', titleKey: 'v2_title' },
  { id: 'uAcybLzDDK4', tagKey: 'v3_tag', titleKey: 'v3_title' },
]

function VideoModal({ videoId, onClose }) {
  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [onClose])

  return (
    <div className="modal-overlay open" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className="video-modal">
        <button className="video-modal-close" onClick={onClose}>✕</button>
        <div className="video-modal-embed">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title="A2G Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  )
}

function VideoCard({ video, t }) {
  const ref = useRef(null)
  const [playing, setPlaying] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('visible') },
      { threshold: 0.1 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <>
      <div ref={ref} className="vcard fade-in" onClick={() => setPlaying(true)} style={{ cursor: 'pointer' }}>
        <div
          className="vcard-thumb-img"
          style={{ backgroundImage: `url(https://img.youtube.com/vi/${video.id}/mqdefault.jpg)` }}
        >
          <div className="video-thumb-overlay" />
          <div className="vcard-play">▶</div>
        </div>
        <div className="vcard-body">
          <div className="vcard-tag">{t[video.tagKey]}</div>
          <div className="vcard-title">{t[video.titleKey]}</div>
        </div>
      </div>
      {playing && <VideoModal videoId={video.id} onClose={() => setPlaying(false)} />}
    </>
  )
}

export default function VideoSection({ t }) {
  const headRef = useRef(null)

  useEffect(() => {
    const el = headRef.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('visible') },
      { threshold: 0.1 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <section className="video-section" id="videos">
      <div className="section-inner">
        <div ref={headRef} className="video-head fade-in">
          <div>
            <div className="section-tag">{t.videos_tag}</div>
            <h2>{t.videos_h2_1}<br /><em>{t.videos_h2_em}</em></h2>
          </div>
          <div>
            <p className="section-desc">{t.videos_desc}</p>
            <a
              href="https://www.youtube.com/@a2g.networks"
              target="_blank"
              rel="noopener noreferrer"
              className="yt-channel-link"
            >
              ▶ {t.videos_yt_cta}
            </a>
          </div>
        </div>
        <div className="video-grid">
          {VIDEOS.map((video) => (
            <VideoCard key={video.id} video={video} t={t} />
          ))}
        </div>
      </div>
    </section>
  )
}
